export const STATUS_GET_REQUEST = "STATUS_GET_REQUEST";
export const STATUS_GET_RECEIVE = "STATUS_GET_RECEIVE";
export const STATUS_GET_ERROR = "STATUS_GET_ERROR";

export const STATUS_AVAILABLE_GET_RECEIVE = "STATUS_AVAILABLE_GET_RECEIVE";

export const STATUS_GROUPS_GET_RECEIVE = "STATUS_GROUPS_GET_RECEIVE";
